// extracted by mini-css-extract-plugin
export default {"navigation":"navigation__ConfigurationsView__fXTQo"};